const PortfolioCardSkeleton = () => {
  return (
    <div className="rounded-2xl border bg-white shadow-sm">
      <div className="h-32 w-full animate-pulse rounded-t-2xl bg-gray-200 object-cover" />
      <div className="p-3">
        <div className="mb-2 h-5 w-40 animate-pulse rounded bg-gray-200" />
        <div className="mb-1 h-4 w-full animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-3/4 animate-pulse rounded bg-gray-200" />
      </div>
    </div>
  )
}

export default PortfolioCardSkeleton
